import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

let sectionHeaderNextId = 0;

@Component({
    selector: 'app-section-header',
    templateUrl: './section-header.component.html',
    styleUrl: './section-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeaderComponent {
    @Input({ required: true }) title!: string;
    @Input() description?: string;

    private readonly instanceId = sectionHeaderNextId++;
    protected readonly titleId = `section-header-title-${this.instanceId}`;
    protected readonly descriptionId = `section-header-description-${this.instanceId}`;
}
